import { SerializedStyles } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { useMerchants } from '@frontend/payments-hooks';
import { ContentLoader } from '@frontend/design-system';
import { CreateMerchant } from '../../../organisms/create-merchant';
import { StripeCard } from './stripe-card';

type StripeStatusProps = {
  style?: SerializedStyles;
  locationId: string;
};

export const StripeStatus = ({ style, locationId }: StripeStatusProps) => {
  const { t } = useTranslation('payments', { keyPrefix: 'settings' });
  const { merchant, activeProcessor, payoutsEnabled, chargesEnabled, hasPayments, merchantFetched } =
    useMerchants(locationId)['firstLocation'];

  const merchantName = !!activeProcessor?.displayName.length ? activeProcessor?.displayName : merchant?.name;

  return (
    <div css={style}>
      <ContentLoader show={!merchantFetched} message={t('Loading Merchant Information')} />
      {locationId &&
        merchantFetched &&
        (hasPayments ? (
          <StripeCard
            activeProcessor={activeProcessor}
            merchantName={merchantName}
            payoutDescriptor={merchant?.payoutDescriptor}
            chargesEnabled={chargesEnabled}
            payoutsEnabled={payoutsEnabled}
            locationId={locationId}
          />
        ) : (
          <CreateMerchant locationId={locationId} />
        ))}
    </div>
  );
};
